export { FigPalette as Palette } from './fig/fig-palette';
export const REM_PX = 16;
export const SPACING = REM_PX / 4;

export function gridPxValue(size: number) {
  return size * SPACING;
}

export function grid2Px(size: number) {
  return `${gridPxValue(size)}px`;
}

export function px2Rem(px: number | `${number}px`): `${number}rem` {
  const pixels = typeof px === 'string' ? parseInt(px) : px;
  return `${pixels / REM_PX}rem`;
}

export function grid2Rem(size: number) {
  return `${gridPxValue(size) / REM_PX}rem`;
}

export function remRange(from: number, to: number, step: number = 1): Record<string, string> {
  return Object.fromEntries(
    Array.from({ length: (to - from) / step + 1 }, (_, i) => from + i * step).map((key) => [
      String(key),
      grid2Rem(key),
    ]),
  );
}

export function fontSize(sizeInPx: number, lineHeightInPx: number): [string, string] {
  const lineHeightRatio = lineHeightInPx / sizeInPx;
  const lineHeight = lineHeightRatio.toFixed(5).replace(/0*$/, '').replace(/\.$/, '');
  return [px2Rem(sizeInPx), lineHeight];
}
